import axios from 'axios';
import { awsLocationApiBaseUrl, awsLocationApiKey } from '../utils/constants';

const CENTRAL_ENGLAND_POSITION = [-2.2426, 53.4808];

export default {
    search: async query => {
        const response = await axios.post(
            `${awsLocationApiBaseUrl}/autocomplete`,
            {
                QueryText: query,
                BiasPosition: CENTRAL_ENGLAND_POSITION,
                MaxResults: 10,
                AdditionalFeatures: ['Core'],
                Language: 'EN'
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {
                    key: awsLocationApiKey
                }
            }
        );

        const allowedPlaceTypes = ['Locality', 'District', 'Neighborhood'];

        const results = response?.data?.ResultItems?.filter(result =>
            allowedPlaceTypes.includes(result?.PlaceType)
        ).map(result => ({
            id: result.PlaceId,
            name: result.Address?.Label,
            district: result.Address?.District || null,
            locality: result.Address?.Locality || null,
            region: result.Address?.Region?.Name || null,
            country: result.Address?.Country?.Name,
            countryCode: result.Address?.Country?.Code3
        }));

        return results;
    }
};
